import React from 'react';
import { cn } from '@/lib/utils';
import { Shield, Wrench, Headphones, LucideIcon } from 'lucide-react';

interface RoleConfig {
  bg: string;
  text: string;
  border: string;
  icon: LucideIcon;
}

const roleConfig: Record<string, RoleConfig> = {
  ADMIN: {
    bg: 'bg-indigo-50 dark:bg-indigo-950',
    text: 'text-indigo-700 dark:text-indigo-400',
    border: 'border-indigo-200 dark:border-indigo-800',
    icon: Shield,
  },
  OPS: {
    bg: 'bg-emerald-50 dark:bg-emerald-950',
    text: 'text-emerald-700 dark:text-emerald-400',
    border: 'border-emerald-200 dark:border-emerald-800',
    icon: Wrench,
  },
  SUPPORT: {
    bg: 'bg-amber-50 dark:bg-amber-950',
    text: 'text-amber-700 dark:text-amber-400',
    border: 'border-amber-200 dark:border-amber-800',
    icon: Headphones,
  },
};

interface RoleBadgeProps {
  role?: string;
  showIcon?: boolean;
  className?: string;
}

export const RoleBadge: React.FC<RoleBadgeProps> = ({ role, showIcon = true, className }) => {
  const config = roleConfig[role?.toUpperCase() ?? ''] || roleConfig.SUPPORT;
  const Icon = config.icon;

  return (
    <span
      data-testid={`role-badge-${role?.toLowerCase()}`}
      className={cn(
        'inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-bold uppercase rounded-md border',
        config.bg,
        config.text,
        config.border,
        className
      )}
    >
      {showIcon && <Icon className="w-3.5 h-3.5" strokeWidth={2} />}
      {role}
    </span>
  );
};
